import React, { memo } from 'react';

import { default as InputFilter } from './components/input';
import { default as CheckboxFilter } from './components/checkbox';
import { default as FiltersDivider } from './components/filters-divider';
import { default as SelectFilter } from './components/select/select';
import MultiSelect from '../multi-select-dropdown/multiSelectDropdown';

import './filter-bar.scss';
import DateRangePickerWrapper, { DateRangePickerProps } from '../date-time-picker/date-range-picker';
import classnames from 'classnames';
import PopOver from '../pop-over/pop-over';
import FilterDatePicker from './components/filter-date-picker';

interface FilterBarProps {
	children: JSX.Element | JSX.Element[];
	className?: string;
}

const FilterBar = ({ className, children }: FilterBarProps) => {
	return <div className={classnames('filters-panel', className)}>{children}</div>;
};

FilterBar.Input = InputFilter;

FilterBar.Checkbox = CheckboxFilter;

FilterBar.Multiselect = MultiSelect;

FilterBar.Select = SelectFilter;

FilterBar.Divider = FiltersDivider;

FilterBar.InputsGroup = memo(({ children }) => <div className="filter-checkbox-group">{children}</div>);

FilterBar.FilterDatePicker = FilterDatePicker;

const DateRangePicker = memo(
	({ startDate, endDate, onChange, translations, className, ...props }: DateRangePickerProps) => (
		<DateRangePickerWrapper
			startDate={startDate}
			endDate={endDate}
			onChange={onChange}
			translations={translations}
			className={className}
			{...props}
		/>
	)
);
FilterBar.DateRangePicker = DateRangePicker;

FilterBar.Popover = PopOver;

export default FilterBar;
